
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from "./components/header/header.component";
import { HomeComponent } from './components/home/home.component';
import { NotificationComponent } from './components/notification/notification.component'
import { PrefCenterComponent } from './components/pref-center/pref-center.component';
import { Environment } from './environments/environment';
import { TruncatePipe } from './pipes/truncate.pipe';
import { CookiesService } from './services/cookies.service';
import { PreferenceService } from './services/preference.service';
import { UsersService } from './services/users.service';
import { DeliveryClosureV2Component } from './components/delivery-closure-v2/delivery-closure-v2.component';
import { DateMonthPipe } from './pipes/date-month.pipe';
import { MonthPipe } from './pipes/month.pipe';
import { MonthStrPipe } from './pipes/month-str.pipe';
import { YearStrPipe } from './pipes/year-str.pipe';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { DayConvertPipe } from './pipes/day-convert.pipe';
import { TodayIconPipe } from './pipes/today-icon.pipe';
import { IsPastPipe } from './pipes/isPast.pipe';
import { AppInterceptorService } from './services/app-interceptor.service';
import { MultiplePharmaciesComponent } from './components/multiple-pharmacies/multiple-pharmacies.component';

import { DeliveryClosureV3Component } from './components/delivery-closure-v3/delivery-closure-v3.component';
import { MonthTransformPipe } from './pipes/month-transform.pipe';
import { IEBannerComponent } from './components/ie-banner/ie-banner.component';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    TruncatePipe,
    PrefCenterComponent,
    HomeComponent,
    NotificationComponent,
    DeliveryClosureV2Component,
    DateMonthPipe,
    MonthPipe,
    MonthStrPipe,
    YearStrPipe,
    DayConvertPipe,
    TodayIconPipe,
    IsPastPipe,
    MultiplePharmaciesComponent,
    DeliveryClosureV3Component,
    MonthTransformPipe,
    IEBannerComponent

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    Ng4LoadingSpinnerModule.forRoot(),
    NgbModule,
  ],
  exports: [
    TruncatePipe
  ],

  providers: [
    UsersService,
    Environment,
    CookiesService,
    PreferenceService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppInterceptorService,
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
